module.exports = __webpack_public_path__ + "img/textBackground.80a80cd3.png";